// 빌드
// ./build.sh commonmain
// ./build.sh shareSearch

// 쿠키값 조회
function getCookie(c_name) {
  let i,x,y,cookies=document.cookie.split(";");
  for (i=0;i<cookies.length;i++) {
    x=cookies[i].substr(0,cookies[i].indexOf("="));
    y=cookies[i].substr(cookies[i].indexOf("=")+1);
    x=x.replace(/^\s+|\s+$/g,"");

    if (x===c_name) {
      return unescape(y);
    }
  }
}

// 쿠키값 설정
function setCookies(c_name,value,exdays) {
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value=escape(value) + ((exdays==null) ? "" : "; path=/; expires="+exdate.toUTCString());
  document.cookie=c_name + "=" + c_value;
}

function getMyKeywordAll() {
  const MYKEYWORD_COUNT = 7; //내가 찾은 검색어 갯수 + 1
  let myKeyword = getCookie("mykeyword");
  if( myKeyword== null) {
    myKeyword = "";
  }

  let myKeywords = myKeyword.split("^%");
  return myKeywords
    .filter(word => word !== null && word !== undefined && word !== "" && word.trim().length > 0 )
    .reverse();
}

// 내가 찾은 검색어 조회
function addMyKeyword(keyword, totCount) {
  const MYKEYWORD_COUNT = totCount + 1; //내가 찾은 검색어 갯수 + 1
  let myKeyword = getCookie("mykeyword");
  if( myKeyword== null) {
    myKeyword = "";
  }

  let myKeywords = myKeyword.split("^%");

  if( totCount > 0 ) {
    let existsKeyword = false;
    for(let i = 0; i < myKeywords.length; i++) {
      if( myKeywords[i] === keyword) {
        existsKeyword = true;
        break;
      }
    }

    if( !existsKeyword ) {
      myKeywords.push(keyword);
      if( myKeywords.length === MYKEYWORD_COUNT) {
        myKeywords = myKeywords.slice(1,MYKEYWORD_COUNT);
      }
    }
    setCookies("mykeyword", myKeywords.join("^%"), 365);
  }

  // showMyKeyword(myKeywords.reverse());
}

// 내가 찾은 검색어 삭제
function removeMyKeyword(keyword) {
  let myKeyword = getCookie("mykeyword");
  if( myKeyword == null) {
    myKeyword = "";
  }

  const myKeywords = myKeyword.split("^%");

  let i = 0;
  while (i < myKeywords.length) {
    if (myKeywords[i] === keyword) {
      myKeywords.splice(i, 1);
    } else {
      i++;
    }
  }

  setCookies("mykeyword", myKeywords.join("^%"), 365);
  // showMyKeyword(myKeywords);
}

function removeAllMyKeyword() {
  setCookies("mykeyword", [].join("^%"), 365);
}

// 내가 찾은 검색어
// function showMyKeyword(myKeywords) {
//   var str = "<h4>내가 찾은 검색어</h4>";
//   str +="<ul class=\"myWord\">";
//
//   for( var i = 0; i < myKeywords.length; i++) {
//     if( myKeywords[i] == "") continue;
//     str +="<li><a href=\"#none\" onClick=\"javascript:doKeyword('"+myKeywords[i]+"');\">"+myKeywords[i]+"</a> <button type=\"button\" onClick=\"removeMyKeyword('"+myKeywords[i]+"');\" >삭제</button></li>"
//
//   }
//   str +="</ul>";
//
//   $("#mykeyword ").html(str);
// }


export default {
  getMyKeywordAll,
  addMyKeyword,
  removeMyKeyword,
  removeAllMyKeyword,
}
